// Масштаб виджета на широких экранах (T15). Zero-блоки Тильды на okinawa25.ru масштабируются
// пропорционально ширине окна, поэтому на большом ноутбуке сайт «растёт», а виджет с фиксированными
// px выглядел мельче страницы. Базовая ширина 1280 — на ней виджет свёрстан; шире — zoom вслед
// за окном, не больше max; уже базы — 1 (телефоны и ноутбуки до 1280 не трогаем).
export function scaleFor(width, { base = 1280, max = 1.5 } = {}) {
  if (!Number.isFinite(width) || width <= base) return 1;
  return Math.min(Math.round((width / base) * 1000) / 1000, max);
}
